import Spinner from '@/ui/Spinner';
// Стили
import './AsyncState.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AsyncState = function AsyncState(_ref) {
    var loading = _ref.loading, error = _ref.error, spinnerWrapperClassName = _ref.spinnerWrapperClassName, errorClassName = _ref.errorClassName, _ref$spinnerSize = _ref.spinnerSize, spinnerSize = _ref$spinnerSize === void 0 ? 'lg' : _ref$spinnerSize;
    if (loading) {
        return /*#__PURE__*/ _jsx("div", {
            className: "async-state__spinner-wrapper ".concat(spinnerWrapperClassName || ''),
            children: /*#__PURE__*/ _jsx(Spinner, {
                size: spinnerSize
            })
        });
    }
    if (!loading && error) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "error-message async-state__error ".concat(errorClassName || ''),
            children: [/*#__PURE__*/ _jsx("span", {
                    className: "error-message__icon",
                    "aria-hidden": "true",
                    children: "\u26A0\uFE0F"
                }), /*#__PURE__*/ _jsxs("span", {
                    className: "error-message__text",
                    children: ["\u041E\u0448\u0438\u0431\u043A\u0430: ", error]
                })]
        });
    }
    return null;
};
export default AsyncState;
